import Marquee from "react-fast-marquee";

const ITEMS = ["CONFERENCE", "EXHIBITION", "BUSINESS NETWORKING", "AWARDS", "VISION 2027"];

export default function Ticker() {
  return (
    <div data-testid="ticker-band" className="overflow-hidden border-y bg-[#123d30] py-4" style={{ borderColor: "var(--line)" }}>
      <Marquee speed={38} gradient={false} direction="right">
        <div className="flex items-center">
          {ITEMS.map((item) => (
            <span key={item} className="flex items-center">
              <span className="font-display text-lg text-[#f3f3e9] sm:text-xl">{item}</span>
              <b className="mx-8 text-[#d7ef8b]">✳</b>
            </span>
          ))}
        </div>
      </Marquee>
    </div>
  );
}
